module.exports = __webpack_public_path__ + "img/cancel.c72bc20c.svg";